import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Typography from 'material-ui/Typography'
import Select from 'material-ui/Select'
import {MenuItem} from 'material-ui/Menu'
import TextField from 'material-ui/TextField'
import {CircularProgress} from 'material-ui/Progress'

import {addressStyles} from '../styles'
import GooglePlacesAutocomplete from '../../../common/components/GooglePlacesAutocomplete'
import LoadingButton from '../../../common/components/LoadingButton'
import {address as text} from '../text'

class Address extends React.Component {

  state = {
    tab: 0,
  }

  setTab = tab => {
    this.props.setTab(tab)
  }

  handleSelectSuggest = (suggest) => {
    this.props.setPostalCode(findAddressComponent(suggest.address_components, 'postal_code').substr(0, 5))
    this.props.setAddress(suggest.formatted_address)
  }

  render() {
    const {classes, tab, addresses, selected, add, error, isFormLoading, isButtonLoading, isButtonDisabled} = this.props
    return (
      <div>
        {tab === 0 ?
          <div>
            <Title classes={classes} text={text.selectOneOfYourAddresses}/>
            <Addresses
              classes={classes}
              isLoading={isFormLoading}
              addresses={addresses}
              selected={selected}
              select={this.props.setSelected}
            />
            <Link classes={classes} text={text.orAddANewAddress} onClick={() => this.setTab(1)}/>
          </div>
          : null
        }
        {
          tab === 1 ?
            <div>
              <Title classes={classes} text={text.addANewAddress}/>
              <AddAddress
                classes={classes}
                isLoading={isFormLoading}
                error={error}
                handleSelectSuggest={this.handleSelectSuggest}
                floor={add.floor}
                setFloor={this.props.setFloor}
                apartment={add.apartment}
                setApartment={this.props.setApartment}
              />
              <Link classes={classes} text={text.orSelectOneOfYourAddresses} onClick={() => this.setTab(0)}/>
            </div>
            : null
        }
        <Actions
          classes={classes}
          isLoading={isButtonLoading}
          isDisabled={isButtonDisabled}
          onClick={
            tab === 0
              ? () => this.props.modifyTransaction()
              : this.props.save}
        />
      </div>
    )
  }

  static propTypes = {
    tab: PropTypes.number,
    setTab: PropTypes.func.isRequired,
    addresses: PropTypes.array,
    selected: PropTypes.number,
    add: PropTypes.shape({
      address: PropTypes.string,
      floor: PropTypes.string,
      apartment: PropTypes.string,
      postalCode: PropTypes.string,
    }),
    save: PropTypes.func.isRequired,
    modifyTransaction: PropTypes.func.isRequired,
    setSelected: PropTypes.func.isRequired,
    setAddress: PropTypes.func.isRequired,
    setFloor: PropTypes.func.isRequired,
    setApartment: PropTypes.func.isRequired,
    setPostalCode: PropTypes.func.isRequired,
    isFormLoading: PropTypes.bool,
    isButtonLoading: PropTypes.bool,
    isButtonDisabled: PropTypes.bool,
    error: PropTypes.string,
  }
}

const Title = ({classes, text}) => (
  <div>
    <Typography variant="title" className={classes.dialogTitle}>{text}</Typography>
  </div>
)

const Link = ({classes, text, onClick}) => (
  <div onClick={onClick}>
    <Typography className={classes.link}>{text}</Typography>
  </div>
)

const Addresses = ({classes, isLoading, addresses, selected, select}) => (
  <div style={{position: 'relative'}}>
    {isLoading === true ? <LoadingBackdrop classes={classes}/> : null}
    <Select
      value={selected}
      onChange={e => select(e.target.value)}
      fullWidth={true}
    >
      {addresses.length === 0 ? <MenuItem key={0} value={0}>...</MenuItem> : null}
      {addresses.map(a => (
        <MenuItem key={a.ID} value={a.ID}>{`${a.Address} - ${a.Floor} ${a.Apartment}`}</MenuItem>
      ))}
    </Select>
  </div>
)

const AddAddress = ({classes, isLoading, error, handleSelectSuggest, floor, setFloor, apartment, setApartment}) => (
  <div style={{position: 'relative'}}>
    {isLoading === true ? <LoadingBackdrop classes={classes}/> : null}
    <GooglePlacesAutocomplete
      apiKey="AIzaSyCv2CdoVDMQ6S8jz2vtDYGTAwJojnxHJus"
      searchParams={{componentRestrictions: {country: 'ar'}, language: 'es', type: ['address']}}
      handleSelectSuggest={
        suggest => handleSelectSuggest(suggest)}
      inputProps={{
        fullWidth: true,
        label: 'Dirección',
        helperText: error,
        error: error.length > 0,
      }}
    />
    <TextField
      label="Piso"
      fullWidth
      value={floor}
      onChange={e => setFloor(e.target.value)}
    />
    <TextField
      label="Departamento"
      fullWidth
      value={apartment}
      onChange={e => setApartment(e.target.value)}
    />
  </div>
)

const Actions = ({classes, isLoading, isDisabled, onClick}) => (
  <div className={classes.dialogActions}>
    <LoadingButton
      variant="raised"
      color="primary"
      onClick={onClick}
      // type="submit"
      disabled={isDisabled}
      isLoading={isLoading}
      className={classes.button}
    >
      Aceptar
    </LoadingButton>
  </div>
)

//TODO refactor into common component
const LoadingBackdrop = ({classes}) => {
  return (
    <div className={classes.loadingContainer}>
      <CircularProgress
        size={24}
        className={classes.progress}
      />
    </div>
  )
}

function findAddressComponent(components, type) {
  for (let i = 0; i < components.length; i++) {
    const types = components[i].types
    const index = types.indexOf(type)
    if (index !== -1) {
      return components[i].short_name.substr(0, 5)
    }
  }
  return ''
}

export default withStyles(addressStyles, {withTheme: true})(Address)



// WEBPACK FOOTER //
// ./src/sections/rent/components/address.js